// Analytics utility for AutoSearchSA
// Tracks page views, clicks, and user sessions

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Generate or retrieve session ID
const getSessionId = () => {
  let sessionId = sessionStorage.getItem('autosearchsa_session');
  if (!sessionId) {
    sessionId = 'sess_' + Math.random().toString(36).substring(2) + Date.now().toString(36);
    sessionStorage.setItem('autosearchsa_session', sessionId);
  }
  return sessionId;
};

// Track page view
export const trackPageView = async (path) => {
  try {
    const sessionId = getSessionId();
    const referrer = document.referrer || null;
    
    await fetch(`${API}/analytics/pageview?path=${encodeURIComponent(path)}&session_id=${sessionId}${referrer ? `&referrer=${encodeURIComponent(referrer)}` : ''}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' }
    });
  } catch (e) {
    console.error('Failed to track page view:', e);
  }
};

// Track external link click
export const trackExternalClick = async (url, linkText, sourcePage) => {
  try {
    const sessionId = getSessionId();
    const params = new URLSearchParams({
      url,
      session_id: sessionId
    });
    if (linkText) params.append('link_text', linkText);
    if (sourcePage) params.append('source_page', sourcePage);
    
    await fetch(`${API}/analytics/external-click?${params.toString()}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' }
    });
  } catch (e) {
    console.error('Failed to track external click:', e);
  }
};

// Higher-order component for tracking external links
export const TrackedExternalLink = ({ href, children, className, ...props }) => {
  const handleClick = () => {
    trackExternalClick(href, typeof children === 'string' ? children : '', window.location.pathname);
  };

  return (
    <a 
      href={href} 
      target="_blank" 
      rel="noopener noreferrer" 
      onClick={handleClick}
      className={className}
      {...props}
    >
      {children}
    </a>
  );
};

export default {
  trackPageView,
  trackExternalClick,
  getSessionId
};
